// extracted by mini-css-extract-plugin
export default {"Container":"wQ3DEJ5u2Hih56XmPjLf","Label":"mIs5FC1ZOq0LlaAXRt_R"};